<navbar-component></navbar-component>

<main class="img-background">
  <div style="display: flex; justify-content: space-between; flex-direction: column; align-items: center; min-height: 80vh;">

    <div class="label-wrapper">
      <img class="label" src="assets/fotos/plate-laundry.svg" />
    </div>

    <div class="products">
      <img src="assets/fotos/empty-shelf-1.svg" />

      <img src="assets/fotos/empty-shelf-2.svg" />

      <img src="assets/fotos/empty-shelf-3.svg" />
    </div>

    <div class="products">
      <img src="assets/fotos/lavanderia-produtos-baixo.svg" />
    </div>

  </div>
</main>

<footer-component></footer-component>
